import { render, staticRenderFns } from "./AvatarLink.vue?vue&type=template&id=e4b17398"
import script from "./AvatarLink.vue?vue&type=script&lang=js"
export * from "./AvatarLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports